import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  FormControlLabel,
  Checkbox,
  Box,
  Button,
  Typography,
} from "@mui/material";
import { createUserWithAssessments } from "../../axios/axiosFunctions";

const CreateUserModal = ({ open, onClose, onUserCreated }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [enrollMIM, setEnrollMIM] = useState(false);
  const [enrollLIM, setEnrollLIM] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const resetForm = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setEnrollMIM(false);
    setEnrollLIM(false);
    setError("");
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleSubmit = async () => {
    setError("");

    if (!email) {
      setError("Email is required.");
      return;
    }

    const assessmentSlugs = [];
    if (enrollMIM) assessmentSlugs.push("mim_self_assessment");
    if (enrollLIM) assessmentSlugs.push("lim_self_assessment");

    setLoading(true);
    const res = await createUserWithAssessments({
      firstName,
      lastName,
      email,
      assessmentSlugs,
    });
    setLoading(false);

    if (!res.user) {
      setError(res.msg || "Error creating user.");
      return;
    }

    resetForm();
    onUserCreated();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle variant="h6" color="primary">
        Create User
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          <Box sx={{ display: "flex", gap: 2 }}>
            <TextField
              label="First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              fullWidth
              size="small"
            />
            <TextField
              label="Last Name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              fullWidth
              size="small"
            />
          </Box>
          <TextField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            size="small"
            required
          />

          <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 1 }}>
            Enroll in Self Assessments
          </Typography>
          <Box sx={{ display: "flex", gap: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={enrollMIM}
                  onChange={(e) => setEnrollMIM(e.target.checked)}
                />
              }
              label="MIM Self Assessment"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={enrollLIM}
                  onChange={(e) => setEnrollLIM(e.target.checked)}
                />
              }
              label="LIM Self Assessment"
            />
          </Box>

          {error && (
            <Typography variant="body2" color="error">
              {error}
            </Typography>
          )}

          <Box sx={{ display: "flex", justifyContent: "end", gap: 2, mt: 1 }}>
            <Button
              onClick={handleSubmit}
              variant="contained"
              color="primary"
              disabled={loading}
            >
              {loading ? "Creating..." : "Create"}
            </Button>
            <Button variant="outlined" onClick={handleClose}>
              Cancel
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CreateUserModal;
